import { render, staticRenderFns } from "./DateRangePicker2.vue?vue&type=template&id=136aa4c6&scoped=true&"
import script from "./DateRangePicker2.vue?vue&type=script&lang=js&"
export * from "./DateRangePicker2.vue?vue&type=script&lang=js&"
import style0 from "./DateRangePicker2.vue?vue&type=style&index=0&id=136aa4c6&prod&lang=scss&"
import style1 from "./DateRangePicker2.vue?vue&type=style&index=1&id=136aa4c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136aa4c6",
  null
  
)

export default component.exports